import React, { useEffect, useState } from 'react';
import EventService from '../../../services/EventService';
import { OfflineCache } from '../../services/OfflineCache';

function EventOverview() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const response = await EventService.getAllEvents();
                const now = new Date();
                const list = (response.data || []).map(e => ({ ...e, eventDate: new Date(e.eventDate) }));
                setEvents(list);
                OfflineCache.saveEvents(list);
            } catch (e) {
                // Offline fallback
                const cached = OfflineCache.getEvents();
                if (cached.length) setEvents(cached.map(e => ({ ...e, eventDate: new Date(e.eventDate) })));
            } finally {
                setLoading(false);
            }
        };
        fetchEvents();
    }, []);

    const openEvent = (id) => {
        window.location.hash = `#/events/${id}`;
    };

    const now = new Date();
    const upcomingEvents = events.filter(ev => ev.eventDate >= now).sort((a, b) => a.eventDate - b.eventDate);
    const pastEvents = events.filter(ev => ev.eventDate < now).sort((a, b) => b.eventDate - a.eventDate);

    return (
        <div className="px-4 py-4">
            <div className="flex items-center justify-between mb-3">
                <h1 className="text-2xl font-bold">Events</h1>
                <button className="bg-blue-600 text-white rounded-md px-4 py-3 text-base" onClick={() => window.location.hash = '#/events/create'}>Create</button>
            </div>
            {loading ? (
                <div className="text-center py-8">Loading...</div>
            ) : (
                <div>
                    {/* Upcoming Events */}
                    {upcomingEvents.length > 0 && (
                        <div className="mb-6">
                            <h2 className="text-xl font-semibold mb-3 text-green-700">📅 Upcoming Events</h2>
                            <div className="rounded-md border divide-y">
                                {upcomingEvents.map(ev => (
                                    <button key={ev.id} className="w-full text-left px-4 py-3 active:bg-gray-50 flex items-center" onClick={() => openEvent(ev.id)}>
                                        {ev.imageUrl ? (
                                            <img src={ev.imageUrl} alt={ev.name} className="w-16 h-16 object-cover rounded mr-3" />
                                        ) : (
                                            <div className="w-16 h-16 bg-gray-200 rounded mr-3 flex items-center justify-center text-xs text-gray-500">No Image</div>
                                        )}
                                        <div className="flex-1">
                                            <p className="font-semibold">{ev.name}</p>
                                            <p className="text-sm text-gray-600">{ev.venue}</p>
                                            <p className="text-sm text-gray-500">{ev.eventDate.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>
                                            <p className="text-sm text-gray-500">{ev.ticketsSold} / {ev.capacity} sold</p>
                                        </div>
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Past Events */}
                    {pastEvents.length > 0 && (
                        <div>
                            <h2 className="text-xl font-semibold mb-3 text-gray-600">📋 Past Events</h2>
                            <div className="rounded-md border divide-y">
                                {pastEvents.map(ev => (
                                    <button key={ev.id} className="w-full text-left px-4 py-3 active:bg-gray-50 flex items-center" onClick={() => openEvent(ev.id)}>
                                        {ev.imageUrl ? (
                                            <img src={ev.imageUrl} alt={ev.name} className="w-16 h-16 object-cover rounded mr-3" />
                                        ) : (
                                            <div className="w-16 h-16 bg-gray-200 rounded mr-3 flex items-center justify-center text-xs text-gray-500">No Image</div>
                                        )}
                                        <div className="flex-1">
                                            <p className="font-semibold">{ev.name}</p>
                                            <p className="text-sm text-gray-600">{ev.venue}</p>
                                            <p className="text-sm text-gray-500">{ev.eventDate.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>
                                            <p className="text-sm text-gray-500">{ev.ticketsSold} / {ev.capacity} sold</p>
                                        </div>
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* No Events */}
                    {upcomingEvents.length === 0 && pastEvents.length === 0 && (
                        <div className="text-center py-8 text-gray-500">
                            <p>No events found</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default EventOverview;


